import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import './caffenioStyle.css';
import lodash from 'lodash';
import moment from 'moment';

// Components
import { toast } from 'react-toastify';
//import { CaffenioForm } from './CaffenioForm';
import Loading from '../util/loading/Loading';
import StepInfoDrive from './driveSteps/StepInfoDrive';
import StepFacturacionDrive from './driveSteps/StepFacturacionDrive';
import StepLocationDrive from './driveSteps/StepLocationDrive';
import Modal from '../util/modal/Modal';
import AcceptModal from '../util/acceptModal/AcceptModal';

// Setvices
import CaffenioDriveAPI from '../../services/SoporteTools';
import PriceDriveAPI from '../../services/PriceDrive';
import MenuDriveAPI from '../../services/MenuDrive';
import ComboDatosAPI from '../../services/ComboDatos';
import PlazaAPI from '../../services/Plazas';
import ErrorMessages from '../../util/validation-error-messages';

/**
 * Formulario para nuevo Drive.
 * @returns Component
 */
export const NewCaffenio = (props) => {
    if (!props.location.state) {
        props.history.push(`/puntos-de-venta`);
    }
     const [state, setState] = useState({
        isLoading: false,
        isEditing: false,
        
        caffenio: props.location.state ? props.location.state.caffenio : null,
        stepInfoDrive: true,
        stepFacturacionDrive: false,
        stepLocationDrive: false,
        stepInfoDriveComplete: false,
        stepFacturacionDriveComplete: false,
        stepLocationDriveComplete: false,
        arrTasaImp: [],
        arrSegmento: [],
        arrPlazas:[],
        arrSucursales:[],
        arrListaPrecio:[],
        arrMenus:[],
        stepsInformation : {},
        showConfirmStep:false, 
        callbakConfirm: ()=>{}, 
        titleConfirm:""
    });

    /**Carga información del form */
    useEffect(() => {        
        setState({
            ...state,
            isLoading: true
        });

        let arrTasaImp = [];
        let arrSegmento = [];
        let arrPlazas = [];
        let arrSucursales = [];
        let isEditing =  props.location.state ? props.location.state.isEditing : false;
        let arrMenus = [];
        let arrListaPrecio = []

        Promise.all([            
            ComboDatosAPI.getTaxRate().then(response => arrTasaImp = lodash.sortBy( response.data.map(x=> {x.label = x.Description; x.value= x.TaxRateId ; return x;}),  [ts => ts.Description.toLowerCase()], ['asc'])),            
            MenuDriveAPI.get().then(response =>arrMenus = lodash.sortBy( response.data.map(x=> {x.label = x.Description; x.value= x.MenuId ; return x;}),  [ts => ts.Description.toLowerCase()], ['asc'])),
            PriceDriveAPI.get().then(response => arrListaPrecio= lodash.sortBy( response.data.map(x=> {x.label = x.Description; x.value= x.PriceListId ; return x;}),  [ts => ts.Description.toLowerCase()], ['asc'])),
            PlazaAPI.getPlazas().then(response => arrPlazas = lodash.sortBy( response.data.map(p => {
                p.label = p.Nombre;
                p.value = p.idPlaza;
                return p;
            }),  [ts => ts.Nombre.toLowerCase()], ['asc'])),
            
            
        ]).catch(err => {
            setState({
                ...state,
                isLoading: false
            })
            if (err.response)
                toast.error(err.response.data.Message)
            else
                toast.error(ErrorMessages.SinConexion)
        }).finally(() => setState({
            ...state,
            arrTasaImp,
            arrSegmento,
            isLoading: false,
            arrPlazas,
            arrSucursales,
            isEditing,
            arrMenus,
            arrListaPrecio
        }));
    }, []);

    /**
     * Regresa a la ruta anterior.
     */
    const handleGoBack = () => {
        window.history.back();
    }

    /**
     * Solo guarda datos generales
     * @param {*} caffenioUpdated 
     */
    const saveDatosGeneralesPortion = (caffenioUpdated) => {
        setState({...state, isLoading:true});
        let stepsInformation = {}
        stepsInformation["datosGeneralesPdv"] = caffenioUpdated
        
        CaffenioDriveAPI.put(state.caffenio.id, stepsInformation)
        .then(response => {
            let caffenio = response.data
            setState({
                ...state,
                caffenio: caffenio,
                isLoading:false, 
                stepInfoDriveComplete: true,
                stepInfoDrive: false,
                stepFacturacionDrive: true,
                
            });
            toast.success('Datos generales actualizado');
           
        })
        .catch(err => {
            let message = 'Ocurrio un error';
            try {
                message = err.response.data.Message;
            } catch (error) {
                message = 'Ocurrió un error al actualizar PDV.';
            } finally {
                toast.error(message);
                setState({ ...state, isLoading: false });
            }
        })
        
    }
    /**
     * Solo referencias 
     * @param {*} caffenioUpdated 
     */
    const saveReferenciasPortion = (caffenioUpdated) => {
        setState({...state, isLoading:true});
        let stepsInformation = {}
        stepsInformation["referenciasPdv"] = caffenioUpdated
        
        CaffenioDriveAPI.put(state.caffenio.id, stepsInformation)
        .then(response => {
            let caffenio = response.data
            setState({
                ...state,
                isLoading:false, 
                stepFacturacionDriveComplete: true,
                stepFacturacionDrive: false,
                stepLocationDrive: true,
                caffenio: caffenio,
            });
            toast.success('Referencias actualizado');
           
        })
        .catch(err => {
            let message = 'Ocurrio un error';
            try {
                message = err.response.data.Message;
            } catch (error) {
                message = 'Ocurrió un error al actualizar PDV.';
            } finally {
                toast.error(message);
                setState({ ...state, isLoading: false });
            }
        })
        
    }
    /**
     * Solo dato de ubicacion
     */
    const saveUbicacionPortion = (caffenioUpdated) => {
        setState({...state, isLoading:true});
        let stepsInformation = {}
        stepsInformation["ubicacionPdv"] = caffenioUpdated
        
        CaffenioDriveAPI.put(state.caffenio.id, stepsInformation)
        .then(response => {
            let caffenio = response.data
            setState({
                ...state,
                caffenio: caffenio,
                stepLocationDriveComplete: true,
                isLoading:false, 
            }); 
            toast.success('Ubicación y dirección actualizado');           
        })
        .catch(err => {
            let message = 'Ocurrio un error';
            try {
                message = err.response.data.Message;
            } catch (error) {
                message = 'Ocurrió un error al actualizar PDV.';
            } finally {
                toast.error(message);
                setState({ ...state, isLoading: false });
            }
        })
        
    }
    /**
     * Manda toda la información
     */
    const saveAllInformation = (caffenioUpdated) => {
        let stepsInformation = {...state.stepsInformation}
        stepsInformation["ubicacionPdv"] = {...caffenioUpdated}
        setState({...state, isLoading:true, stepsInformation: stepsInformation});        
        
        CaffenioDriveAPI.put(state.caffenio.id, stepsInformation)
        .then(response => {
            let caffenio = response.data            
            setState({
                ...state,
                caffenio: caffenio,
                stepLocationDriveComplete: true,
                isLoading:false,
                stepsInformation
            }); 
            toast.success('Drive actualizado');
        })
        .catch(err => {
            let message = 'Ocurrio un error';
            try {
                message = err.response.data.Message;
            } catch (error) {
                message = 'Ocurrió un error al actualizar PDV.';
            } finally {
                toast.error(message);
                setState({ ...state, isLoading: false });
            }
        })
    }

    const confirmStep = (modalBody , callbak) => {
        setState({
            ...state,
            showConfirmStep:true,
            titleConfirm:modalBody,
            callbakConfirm:callbak 
        })
        
    }

    return (
        <div>
            {
                state.isLoading &&
                <Loading
                    isFullscreen={true}
                    isLoading={state.isLoading}
                    width='100px'
                    height='100px'
                />
            }   
            <div className="card">
                <div className="card-header">
                    <div className="card-header-title is-size-4 center-text">
                        <span style={{ position: "absolute", left: 25 }} className="is-primary tooltip" data-tooltip="Ir Atrás">
                            <i
                                className="fa fa-arrow-left"
                                style={{ cursor: "pointer", color: "#91BA43" }}
                                onClick={handleGoBack}
                            />
                        </span>
                        
                        <div>
                            {`${state.isEditing ? "Editar Drive": "Nuevo Drive" }`}
                            
                        </div>
                    </div>
                </div>
                <div className="card-content">
                    <div>
                        <div className="steps" id="stepsRecipes">
                            <div className={`step-item ${state.stepInfoDrive ? "is-active" : ""} ${state.stepInfoDriveComplete ? "is-success" : ""}`} id="stepInfoDrive">
                                <div className="step-marker">1</div>
                                <div className="step-details">
                                    <p className="step-title">Datos generales</p>
                                    <p></p>
                                </div>
                            </div>
                            <div className={`step-item ${state.stepFacturacionDrive ? "is-active" : ""} ${state.stepFacturacionDriveComplete ? "is-success" : ""}`} id="stepFacturacionDrive">
                                <div className="step-marker">2</div>
                                <div className="step-details">
                                    <p className="step-title">Catalogos</p>
                                    <p></p>
                                </div>
                            </div>
                            <div className={`step-item ${state.stepLocationDrive ? "is-active" : ""} ${state.stepLocationDriveComplete ? "is-success" : ""}`} id="stepLocationDrive">
                                <div className="step-marker">3</div>
                                <div className="step-details">
                                    <p className="step-title">Ubicación y Dirección</p>
                                    <p></p>
                                </div>
                            </div>

                            <div className="steps-content" style={{ width: 100 }} id="stepDriveContent">
                                <div className={`step-content has-text-centered ${state.stepInfoDrive ? "is-active" : ""}`} id="stepInfoDrive">
                                    {!state.isLoading &&
                                        <StepInfoDrive
                                            isEditing={state.isEditing}
                                            caffenio={state.caffenio}
                                            segmentos={props.location.state ? props.location.state.segmentos : []}
                                            save = {(caffenioUpdated) => {
                                                confirmStep("¿Está seguro de actualizar la sección de DATOS GENERALES del punto de venta?", ()=>saveDatosGeneralesPortion(caffenioUpdated)); 
                                            }}
                                            nextWithoutSave= {(steapInfo) => {
                                                let stepsInformation = {...state.stepsInformation}
                                                stepsInformation["datosGeneralesPdv"] = {...steapInfo}
                                                setState({
                                                    ...state,
                                                    stepInfoDriveComplete: true,
                                                    stepInfoDrive: false,
                                                    stepFacturacionDrive: true,
                                                    stepsInformation
                                                })}
                                            }
                                            
                                        />
                                  } 
                                </div>
                                <div className={`step-content has-text-centered ${state.stepFacturacionDrive ? "is-active" : ""}`} id="stepFacturacionDrive">
                                    {!state.isLoading && state.stepFacturacionDrive  &&
                                    <StepFacturacionDrive
                                        isEditing={state.isEditing}
                                        caffenio={state.caffenio}
                                        TasaImp={state.arrTasaImp}
                                        segmentos={state.arrSegmento}
                                        plazas={state.arrPlazas}
                                        menus={state.arrMenus}
                                        listasPrecio={state.arrListaPrecio}
                                        save={(caffenioUpdated) => confirmStep("¿Está seguro de actualizar la sección de REFERENCIAS del punto de venta?", () => saveReferenciasPortion(caffenioUpdated)) }
                                        back = {(caffenioUpdated) => {                                            
                                            setState({
                                                ...state,                                                
                                                stepFacturacionDrive: false,
                                                stepInfoDrive: true,
                                                caffenio: caffenioUpdated
                                            });                                           
                                        }}
                                        nextWithoutSave={(steapInfo) => {
                                            let stepsInformation = {...state.stepsInformation}
                                            stepsInformation["referenciasPdv"] = {...steapInfo}
                                            setState({
                                                ...state,
                                                stepFacturacionDriveComplete: true,
                                                stepFacturacionDrive: false,
                                                stepLocationDrive: true,
                                                stepsInformation
                                            });
                                        }}
                                    />
                                     }  
                                </div>
                                <div className={`step-content has-text-centered ${state.stepLocationDrive ? "is-active" : ""}`} id="stepLocationDrive">
                                    {!state.isLoading && state.stepLocationDrive &&
                                    <StepLocationDrive
                                        isEditing={state.isEditing}
                                        caffenio={state.caffenio}                                        
                                        save = {(caffenioUpdated) => confirmStep("¿Está seguro de actualizar la sección de UBICACIÓN Y DIRECCIÓN del punto de venta?", () =>  saveUbicacionPortion(caffenioUpdated)) }
                                        saveAll = {(caffenioUpdated) => confirmStep("¿Está seguro de actualizar TODA la información del punto de venta?", () => saveAllInformation(caffenioUpdated))}                                        
                                        back = {(caffenioUpdated) => {
                                            setState({
                                            ...state,                                            
                                            stepFacturacionDrive: true,
                                            stepLocationDrive: false,
                                            caffenio: caffenioUpdated
                                        })
                                        }} />
                                          } 
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            
            {state.showConfirmStep &&
                    <Modal
                        showModal={state.showConfirmStep}
                        modalTitle={"Confirmar"}
                        cancel={() => setState({...state, showConfirmStep:false, titleConfirm:"", callbakConfirm: ()=>{}})}
                        footer
                        footerButtons={                        
                            <div className="has-text-right modal-detalle-buttons">
                                <button className="button is-success" onClick={state.callbakConfirm}>Guardar</button>
                                
                            </div>
                        }
                    >
                        <div className="has-text-justified">

                            {state.titleConfirm}
                            <hr />
                            
                        </div>


                    </Modal>
                }
            
            
           
        </div>
    );
}

// Definición de los tipos y su dependencia de las distintas props que recibe el componente.
NewCaffenio.propTypes = {
    caffenio: PropTypes.object,
    isEditing: PropTypes.bool
}

// Definición de los valores por default de las props en caso de no ser recibidas por el padre.
NewCaffenio.defaultProps = {
    isEditing: false,
    caffenio: {
        ShortName: "",
        Name: "",
        SatCode: ""
    }
}

export default NewCaffenio;